import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostCollection_pointsInvoicesParse_data = z.any()
export type TagsPostCollection_pointsInvoicesParse_data = z.infer<typeof tagsPostCollection_pointsInvoicesParse_data>

export const descriptionPostCollection_pointsInvoicesParse_data = z.any()
export type DescriptionPostCollection_pointsInvoicesParse_data = z.infer<typeof descriptionPostCollection_pointsInvoicesParse_data>

export const consumesPostCollection_pointsInvoicesParse_data = z.any()
export type ConsumesPostCollection_pointsInvoicesParse_data = z.infer<typeof consumesPostCollection_pointsInvoicesParse_data>

export const querystringPostCollection_pointsInvoicesParse_data = z.object({ "buildingId": z.string().uuid().optional(), "collectionPointId": z.string().uuid().optional(), "parseMode": z.union([z.literal("single"), z.literal("bulk")]).optional(), "progressId": z.string().uuid().optional() })
export type QuerystringPostCollection_pointsInvoicesParse_data = z.infer<typeof querystringPostCollection_pointsInvoicesParse_data>

export const bodyPostCollection_pointsInvoicesParse_data = z.object({ "attachment": z.union([z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string().optional(), "file": z.any(), "type": z.string().optional() }), z.array(z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string().optional(), "file": z.any(), "type": z.string().optional() }))]) })
export type BodyPostCollection_pointsInvoicesParse_data = z.infer<typeof bodyPostCollection_pointsInvoicesParse_data>

export const responsePostCollection_pointsInvoicesParse_data = z.object({ "payload": z.any().optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostCollection_pointsInvoicesParse_data = z.infer<typeof responsePostCollection_pointsInvoicesParse_data>

interface IPostCollection_pointsInvoicesParse_data extends BaseMethodType {
  tags: TagsPostCollection_pointsInvoicesParse_data,
  description: DescriptionPostCollection_pointsInvoicesParse_data,
  consumes: ConsumesPostCollection_pointsInvoicesParse_data,
  querystring: QuerystringPostCollection_pointsInvoicesParse_data,
  body: BodyPostCollection_pointsInvoicesParse_data,
  response: ResponsePostCollection_pointsInvoicesParse_data
}
export const URL = '/collection-points/invoices/parse-data'
export const validation = {
  post: {
    tags: tagsPostCollection_pointsInvoicesParse_data,
    description: descriptionPostCollection_pointsInvoicesParse_data,
    consumes: consumesPostCollection_pointsInvoicesParse_data,
    querystring: querystringPostCollection_pointsInvoicesParse_data,
    body: bodyPostCollection_pointsInvoicesParse_data,
    response: responsePostCollection_pointsInvoicesParse_data
  }
}
export interface Collection_pointsInvoicesParse_data extends BaseRouteType {
  post: IPostCollection_pointsInvoicesParse_data
}